import { defineStore } from 'pinia';
import { Store } from '@/setup/globals';
import { PointOfService } from '@/types/point-of-service';

type State = {
  location: PointOfService;
}

export type InitialData = {
  data: {
    pointOfService: PointOfService;
  };
}

const storeName = Store.LocationDetail;

export default defineStore(storeName, {
  state: (): State => {
    const initialData = window.initialData?.[storeName];

    if (!initialData) {
      throw new Error(`Initial data for ${storeName} store missing`);
    }

    return {
      location: initialData.data.pointOfService,
    };
  },
  getters: {},
});
